
import {TopicSearch} from 'components/search-dropdown'
import {markRaw} from 'vue'
import TrackerSegment from 'pages/pulse/tracker/tracker-segment.vue'
import TrackerButtongroup from 'pages/pulse/tracker/tracker-buttongroup.vue'
import TrackerTextarea from 'pages/pulse/tracker/tracker-textarea.vue'
import {COMPANY_ALERTS, TOPIC_SENSITIVITY} from 'consts/tracker'

export default {
  components: {TopicSearch, TrackerSegment, TrackerButtongroup, TrackerTextarea},
  emits: ['submit'],
  data() {
    return {
      user_id: undefined,
      chosen_topic: undefined,
      ALERTS: markRaw(COMPANY_ALERTS),
      SENSITIVITY: markRaw(TOPIC_SENSITIVITY),
      tracker_focus: 'balanced',
      tracker_alerts: 'all',
      focus_on: undefined,
      loading: false,
    }
  },
  computed: {
    can_submit() {
      return !!this.chosen_topic?.shared_topic_id
    }
  },
  methods: {
    open(user_id){
      this.chosen_topic = undefined
      this.tracker_focus = 'balanced'
      this.tracker_alerts = 'all'
      this.focus_on = undefined
      this.user_id = user_id
      this.loading = false
      this.$refs.modal.open()
    },
    close(force) {
      if (!force && this.loading) return
      this.$refs.modal.close()
      this.user_id = undefined
    },
    submit() {
      this.loading = true
      this.$emit('submit', {
        chosen_topic: this.chosen_topic,
        tracker_focus: this.tracker_focus,
        tracker_alerts: this.tracker_alerts,
        focus_on: this.focus_on,
      })
    }
  }
}
